import { api } from 'boot/axios';
export class CurrentParish {
    parish;
    constructor(p) {
        this.parish = p;
    }
    static async getInstance() {
        const parishResponse = await api.get('/api/parishes/current');
        return new CurrentParish(parishResponse.data);
    }
    get() {
        return this.parish;
    }
}
